export const headerContainerStyled = { maxWidth: '1280px' }

export const headerStyled = {
  backgroundColor: 'var(--flora--colors-brand-1)',
  color: '#ffffff',
  padding: '16px 0',
}

export const footerStyled = {
  backgroundColor: 'var(--flora--colors-light-dark-1)',
  color: 'var(--flora--colors-dark-light)',
  padding: '20px 8px',
  marginTop: '56px',
}

export const hiddenColumns = {
  display: 'none',
  '@tablet': {
    display: 'flex',
  },
}

export const cardsMobileAdapter = {
  flexDirection: 'column',
  alignItems: 'center',
  gap: 8,
  '@fullscreen': {
    flexDirection: 'row',
    gap: 32,
  },
}

export const mobileAdapter = {
  flexDirection: 'column',
  alignItems: 'center',
  '@fullscreen': {
    flexDirection: 'row',
  },
}

export const flexStyled = {
  height: '100%',
}

export const containerStyled = {
  display: 'flex',
  flex: 1,
  alignItems: 'center',
}
